import React from "react";
import TitleBar from "../components/TitleBar";
import RaisedButton from "../components/RaisedButton";
import InnerBody from "../components/InnerBody";
import Header from "../components/Header";
import NavigationSideBar from "../components/NavigationSideBar";
import withAuthorization from "../firebase/withAuthorization";
import { getSingleClientUpdates } from "../firebase/firestore";
import withAccount from "../utils/withAccount";
import ClientPicture from "../components/ClientPicture";
import TextInput from "../components/TextInput";

class PageManageClient extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      clientId: this.props.match.params.clientId,
      deleteDialogVisible: false,
      clientData: {
        name: "",
        contactPerson: {
          name: "",
          logo_url: "",
          contact_person: { first: "", last: "", email: "" }
        }
      }
    };

    this.clientUpdatesUnsub = null;
  }

  componentDidMount() {
    this.fetchData();
  }

  componentWillUnmount() {
    if (this.clientUpdatesUnsub) this.clientUpdatesUnsub();
  }

  fetchData() {
    const { account } = this.props;
    const { clientId } = this.state;

    this.clientUpdatesUnsub = getSingleClientUpdates(
      account.id,
      clientId,
      c => {
        if (c.exists) {
          this.setState({
            isLoading: false,
            clientData: {
              id: c.id,
              name: c.data().name,
              logo_url: c.data().logo_url,
              contactPerson: c.data().contact_person,
              created: c.data().created
            }
          });
        } else {
          this.props.history.replace("/dash/clients");
        }
      }
    );
  }

  isValidClient(clientId) {
    const { clients } = this.state;
    for (var i = 0; i < clients.length; i++) {
      if (clients[i].id === clientId) {
        return true;
      }
    }
    return false;
  }

  render() {
    const { account } = this.props;
    const { clientData } = this.state;
    const contactPerson = clientData.contactPerson;

    return (
      <div>
        <Header
          title={clientData.name}
          showProjectsDropdown={false}
          showProfile={true}
        />
        <NavigationSideBar page="clients" />
        <InnerBody isLoading={this.state.isLoading}>
          <TitleBar title="Kundendaten">
            <RaisedButton
              label="Speichern"
              onClick={() => this.props.history.push("./edit")}
            />
          </TitleBar>
          <h4>Unternehmen</h4>
          <ClientPicture big account={account} clientId={clientData.id} />
          <TextInput placeholder="Firmenname" value={clientData.name} />
          <h4>Kontaktperson</h4>
          <TextInput placeholder="Vorname" value={contactPerson.first} />
          <TextInput placeholder="Nachname" value={contactPerson.last} />
          <TextInput placeholder="E-Mail" value={contactPerson.email} />
        </InnerBody>
      </div>
    );
  }
}

const authCondition = authUser => !!authUser;
export default withAuthorization(authCondition)(withAccount(PageManageClient));



// WEBPACK FOOTER //
// ./src/pages/PageManageClient.js